import React, { useState, useEffect, useContext } from 'react';
import { ColorContext } from '../../../Components/ColorContext/ColorContext';
import adminapi, { getSandboxApis, getSandboxApisStatus, updateSandboxApisStatus, getSandboxCategoryStatus, updateSandboxCategoryStatus, getApisStatusByUsername, getCategoryStatusByUsername } from '../../../Base/AdminConfig';
import Message from '../../../Components/Message/Message';
import Loading from '../../../Components/Loading/Loading';
import styles from "../user-accounts.module.css";

export default function APIStatus(props) {
    const userId = props.details.userId;
    const { userName, css } = useContext(ColorContext);
    const [ sandboxApiList, setSandboxApiList ] = useState([]);
    const [ categoryAndServices, setCategoryAndServices ] = useState([]);
    const [ apiList, setApiList ] = useState({});
    const [ loading, setLoading ] = useState(true);
    const [ updateLoader, setUpdateLoader ] = useState(false);
    const [ message, setMessage ] = useState('');
    const [ messageClass, setMessageClass ] = useState('');
    const [ tabName, setTabName ] = useState('api-name');
    const [ categoryStatus, setCategoryStatus ] = useState('');
    const [ apiStatusUsername, setApiStatusUsername ] = useState('');
    const [ categoryStatusUsername, setCategoryStatusUsername ] = useState('');
    let apiCount = 0;
    let categoryCount = 0;

    useEffect(() => {
        if(userName){
            // Fetch API status by user id
            fetchDefaultFunction();
            fetchCategoryStatusFunction();
            // Fetch API status by username
            fetchApiStatusByUsernameFunction();
            fetchCategoryStatusByUsernameFunction();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userName])

    const fetchDefaultFunction = () => {
        adminapi.get(getSandboxApis)
        .then((res) => {
            if(res.data.code === 200){
                setSandboxApiList(res.data.apiData);
                fetchApiStatusFunction(res.data.apiData);
                setCategoryAndServices(getCategoriesWithServices(res.data.apiData));
            } else {
                setLoading(false);
                setSandboxApiList([]);
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error(error);
        })
    }

    const fetchApiStatusFunction = (apiData) => {
        adminapi.get(getSandboxApisStatus + userName + '/' + userId)
        .then((res) => {
            setLoading(false);
            if(res.data.code === 200){
                setApiList(res.data.apis);
            } else {
                setApiList(getAllKeysFunction(apiData));
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error(error);
        })
    }

    const getAllKeysFunction = (list) => {
        return list.reduce((acc, item) => {
            if (item.services) {
                acc[item.services] = true;
            }
            return acc;
        }, {});
    }

    const updateApiStatusFunction = (key, value) => {
        setUpdateLoader(true);
        adminapi.post(updateSandboxApisStatus, {
            userId: userId,
            userName,
            key,
            value
        })
        .then((res) => {
            setUpdateLoader(false);
            if(res.data.code === 200){
                fetchApiStatusFunction();
                fetchCategoryStatusFunction();
                setMessageClass('success');
                setMessage(res.data.message);
                setTimeout(() => {
                    setMessage('')
                }, 2000);
            } else {
                setMessageClass('error');
                setMessage(res.data.message);
                setTimeout(() => {
                    setMessage('')
                }, 2000);
            }
        })
        .catch((error) => {
            setUpdateLoader(false);
            console.error(error);
        })
    }

    function getCategoriesWithServices(apiData) {
        const categoryMap = apiData.reduce((acc, item) => {
            if (item.category && item.services) {
                if (!acc[item.category]) {
                    acc[item.category] = [];
                }
                acc[item.category].push({
                    name: item.name,
                    services: item.services
                });
            }
            return acc;
        }, {});
        return Object.entries(categoryMap).map(([category, services]) => ({
            category,
            services
        }));
    }

    const fetchCategoryStatusFunction = () => {
        adminapi.get(getSandboxCategoryStatus + userName + '/' + userId)
        .then((res) => {
            if(res.data.code === 200){
                setCategoryStatus(res.data.categoriesStatus);
            } else {
                setLoading(false);
                setCategoryStatus('');
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error(error);
        })
    }

    const updateCategoryStatusFunction = (category, value) => {
        setUpdateLoader(true);
        adminapi.post(updateSandboxCategoryStatus, {
            userId: userId,
            userName,
            category,
            value
        })
        .then((res) => {
            setUpdateLoader(false);
            if(res.data.code === 200){
                fetchApiStatusFunction();
                fetchCategoryStatusFunction();
                setMessageClass('success');
                setMessage(res.data.message);
                setTimeout(() => {
                    setMessage('')
                }, 2000);
            } else {
                setMessageClass('error');
                setMessage(res.data.message);
                setTimeout(() => {
                    setMessage('')
                }, 2000);
            }
        })
        .catch((error) => {
            setUpdateLoader(false);
            console.error(error);
        })
    }

    const fetchApiStatusByUsernameFunction = () => {
        adminapi.get(getApisStatusByUsername + userName)
        .then((res) => {
            if(res.data.code === 200){
                setApiStatusUsername(res.data.apis);
            } else {
                setApiStatusUsername('');
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error(error);
        })
    }

    const fetchCategoryStatusByUsernameFunction = () => {
        adminapi.get(getCategoryStatusByUsername + userName)
        .then((res) => {
            if(res.data.code === 200){
                setCategoryStatusUsername(res.data.categoriesStatus);
            } else {
                setCategoryStatusUsername('');
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error(error);
        })
    }
    
    return (<>
        {message && <Message message={message} messageClass={messageClass} closeMessage={() => setMessage('')} />}
        {updateLoader && <div className={styles['update-loader']}><Loading /></div>}
        {
            loading
            ?<Loading />
            :<>
                <ul className={styles['api-status-tabs']}>
                    <li style={tabName === 'api-name' ? css.active : null} onClick={() => setTabName('api-name')}>Status by API name</li>
                    <li style={tabName === 'category-name' ? css.active : null} onClick={() => setTabName('category-name')}>Status by category name</li>
                </ul>
                {tabName === 'api-name' && <>
                    <div className={styles['plan-head']}>
                        <p>#</p>
                        <p>Category</p>
                        <p>API name</p>
                        <p>Description</p>
                        <p>Action</p>
                    </div>
                    {sandboxApiList.map((item, i) => {
                        if(apiStatusUsername && apiStatusUsername[item.services] === false){
                            return null;
                        } else {
                            apiCount ++;
                            return (
                                <div className={styles['plan-body']} key={i}>
                                    <p><span>#</span> {apiCount}</p>
                                    <p><span>Category:</span> {item.category}</p>
                                    <p><span>API name:</span> {item.name}</p>
                                    <p><span>Description</span> {item.description}</p>
                                    <div>
                                        <span className={styles[!(apiList[item.services]===false) ? 'visible' : '']} onClick={() => updateApiStatusFunction(item.services, true)}><i className={`fa fa-${!(apiList[item.services]===false) ? 'check-' : ''}circle-o`}></i> Show</span>
                                        <span className={styles[!(apiList[item.services]===false) ? '' : 'hidden']} onClick={() => updateApiStatusFunction(item.services, false)}><i className={`fa fa-${(apiList[item.services]===false) ? 'check-' : ''}circle-o`}></i> Hide</span>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </>}
                {tabName === 'category-name' && <>
                    <div className={styles['category-head']}>
                        <p>#</p>
                        <p>Category</p>
                        <p>Services</p>
                        <p>Action</p>
                    </div>
                    {categoryAndServices.map((item, i) => {
                        if(categoryStatusUsername && categoryStatusUsername[item.category] === false){
                            return null;
                        } else {
                            categoryCount ++;
                            return (
                                <div className={styles['category-body']} key={i}>
                                    <p>{categoryCount}</p>
                                    <p>{item.category}</p>
                                    <p>{item.services.map((item, i) => <span key={i}>{item.name}</span>)}</p>
                                    <div>
                                        <span className={styles[!(categoryStatus[item.category]===false) ? 'visible' : '']} onClick={() => updateCategoryStatusFunction(item.category, true)}><i className={`fa fa-${!(apiList[item.category]===false) ? 'check-' : ''}circle-o`}></i> Show</span>
                                        <span className={styles[!(categoryStatus[item.category]===false) ? '' : 'hidden']} onClick={() => updateCategoryStatusFunction(item.category, false)}><i className={`fa fa-${(apiList[item.category]===false) ? 'check-' : ''}circle-o`}></i> Hide</span>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </>}
            </>
        }
    </>);
}